window.addEventListener('load', function(){
    // obtain plugin
    var cc = initCookieConsent();

    // run plugin with your configuration
    cc.run({
        current_lang: 'it',
        autoclear_cookies: true,                   // default: false
        page_scripts: true,                        // default: false

        // mode: 'opt-in'                          // default: 'opt-in'; value: 'opt-in' or 'opt-out'
        // delay: 0,                               // default: 0
        // auto_language: null                     // default: null; could also be 'browser' or 'document'
        // autorun: true,                          // default: true
        // force_consent: false,                   // default: false
        // hide_from_bots: false,                  // default: false
        // remove_cookie_tables: false             // default: false
        // cookie_name: 'cc_cookie',               // default: 'cc_cookie'
        // cookie_expiration: 182,                 // default: 182 (days)
        // cookie_necessary_only_expiration: 182   // default: disabled
        // cookie_domain: location.hostname,       // default: current domain
        // cookie_path: '/',                       // default: root
        // cookie_same_site: 'Lax',                // default: 'Lax'
        // use_rfc_cookie: false,                  // default: false
        // revision: 0,                            // default: 0

        onFirstAction: function(user_preferences, cookie){
            // callback triggered only once
        },

        onAccept: function (cookie) {
            // callback triggered on the first accept/reject action, and after each page load
            // if(cc.allowedCategory('analytics')){
            //     gtag('consent', 'update', {
            //         'ad_storage': 'granted',
            //         'analytics_storage': 'granted'
            //     });
            // }
            // if(cc.allowedCategory('targeting')){
            //     fbq('consent', 'grant');
            // }
        },

        onChange: function (cookie, changed_preferences) {
            // callback triggered when user changes preferences after consent has already been given
            // if(cc.allowedCategory('analytics') === false){
            //     gtag('consent', 'update', {
            //         'ad_storage': 'denied',
            //         'analytics_storage': 'denied'
            //     });
            // } else {
            //     gtag('consent', 'update', {
            //         'ad_storage': 'granted',
            //         'analytics_storage': 'granted'
            //     });
            // }
            // if(cc.allowedCategory('targeting') === false){
            //     fbq('consent', 'revoke');
            // } else {
            //     fbq('consent', 'grant');
            // }
        },

        gui_options: {
            consent_modal: {
                layout: 'cloud',               // box/cloud/bar
                position: 'bottom center',     // bottom/middle/top + left/right/center
                transition: 'slide',           // zoom/slide
                swap_buttons: false            // enable to invert buttons
            },
            settings_modal: {
                layout: 'box',                 // box/bar
                // position: 'left',           // left/right
                transition: 'slide'            // zoom/slide
            }
        },

        languages: {
            'it': {
                consent_modal: {
                    title: ' I Cookie rendono le cose migliori!',
                    description: 'Utilizziamo cookie e identificatori di prima o terza parte con il tuo consenso e/o nostro interesse legittimo, allo scopo di immagazzinare o accedere alle informazioni sul tuo dispositivo, per raccogliere dati personali degli utenti per sviluppare e migliorare prodotti, nonché per visualizzare e misurare pubblicità  nostra e/o di terzi e/o contenuti personalizzati basati sulla tua navigazione (ad esempio le pagine visitate).', //
                    primary_btn: {
                        text: 'Accetto tutti i Cookie',
                        role: 'accept_all'              // 'accept_selected' or 'accept_all'
                    },
                    secondary_btn: {
                        text: 'Impostazioni',
                        role: 'settings'        // 'settings' or 'accept_necessary'
                    }
                },
                settings_modal: {
                    title: 'Centro preferenze sulla privacy',
                    save_settings_btn: 'Salva le impostazioni',
                    accept_all_btn: 'Accetta tutti',
                    reject_all_btn: 'Rifiuta tutti',
                    close_btn_label: 'Close',
                    cookie_table_headers: [
                        {col1: 'Nome'},
                        {col2: 'Dominio'},
                        {col3: 'Scadenza'},
                        {col4: 'Tipo'}
                    ],
                    blocks: [
                        {
                            title: 'Opzioni Cookie',
                            description: 'Questo sito Web utilizza cookie essenziali per garantirne il corretto funzionamento e cookie di tracciamento per capire come interagisci con esso. Quest\'ultimo sarà impostato solo previo consenso.'
                        }, {
                            title: 'Cookie strettamente necessari',
                            description: "Questi cookie sono necessari per il funzionamento del sito e non possono essere disattivati nei nostri sistemi. Di solito vengono impostati solo in risposta alle azioni da te effettuate che costituiscono una richiesta di servizi, come l'impostazione delle preferenze di privacy, l'accesso o la compilazione di moduli. È possibile impostare il browser per bloccare o avere avvisi riguardo questi cookie, ma di conseguenza alcune parti del sito non funzioneranno. Questi cookie non archiviano informazioni personali.",
                            toggle: {
                                value: 'necessary',
                                enabled: true,
                                readonly: true          // cookie categories with readonly=true are all treated as "necessary cookies"
                            },
                            cookie_table: [             // list of all expected cookies
                                {
                                    col1: 'october_session',
                                    col2: 'veronicafilippi.com',
                                    col3: 'Sessione',
                                    col4: 'HTTP - Conserva lo stato della sessione del visitatore tra le richieste di pagina.',
                                    is_regex: true
                                },
                            ],
                        }, {
                            title: 'Maggiori informazioni',
                            description: 'Per maggiori informazioni consulta l\'informativa sulla  <a href="/privacy-policy" class="cc-link">privacy</a> e sui <a href="/cookie-policy" class="cc-link">cookie</a>.',
                        }
                    ]
                }
            },
        }
    });
});
